var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-center"},[_c('span',[(_vm.loading)?_c('i',{staticClass:"fa-2x fa-spin fa-spinner fas primaryColor"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }